/** KV 다건 목록 — 엔티티 타입별 표시 라벨 */
export const KV_LIST_TYPES = {
    asset: "asset",
    user: "user",
    contract: "contract",
};

const labelGetters = {
    [KV_LIST_TYPES.asset]: (item) => item?.assetName ?? item?.name ?? item?.title ?? "",
    [KV_LIST_TYPES.user]: (item) => item?.name ?? item?.userName ?? item?.login ?? "",
    [KV_LIST_TYPES.contract]: (item) => item?.name ?? item?.title ?? "",
};

export function getKvListLabel(item, listType = KV_LIST_TYPES.asset) {
    const getter = labelGetters[listType] ?? labelGetters[KV_LIST_TYPES.asset];
    return getter(item);
}

const countUnits = {
    [KV_LIST_TYPES.asset]: "개",
    [KV_LIST_TYPES.user]: "명",
    [KV_LIST_TYPES.contract]: "건",
};

/** 요약 문구 단위 — 자산: 개, 사용자: 명, 계약: 건 */
export function getKvListCountUnit(listType = KV_LIST_TYPES.asset) {
    return countUnits[listType] ?? countUnits[KV_LIST_TYPES.asset];
}

export const KV_LIST_INLINE_MAX = 3;

export function formatKvListInline(labels) {
    return (labels || []).filter(Boolean).join(", ");
}

export function formatKvListSummary(firstLabel, restCount, listType = KV_LIST_TYPES.asset) {
    const unit = getKvListCountUnit(listType);
    return `${firstLabel} 외 ${restCount}${unit}`;
}
